import {
  Dictionary
} from "./Dictionary";
import {
  comp_name_config
} from "./comp_name_config";

function comp_name_utils() {
}

comp_name_utils.prototype.showGameName = function(gameid, comp_name) {
  var result = "lang.str_" + gameid;
  var dict = comp_name_config.game_config;
  if (!dict) {
    return result;
  }
  var game_array = dict.safeGetObject(gameid);
  if(game_array && game_array.length > 0) {
    for(var i = 0; i < game_array.length; i++) {
      var game_dict = game_array[i];
      if(game_dict && game_dict.comp) {
        for (var j = 0; j < game_dict.comp.length; j++) {
          if (game_dict.comp[j].toLowerCase()  == comp_name.toLowerCase() ) {
            result = "lang.str_" + gameid + game_dict.pretix;
            return result;
          }
        }
      }
    }
  }

  return result;
}

export {
  comp_name_utils
};



//////////////////
// WEBPACK FOOTER
// ./untils/comp_name_utils.js
// module id = null
// module chunks = 